import React, { useEffect, useState } from "react";
import TableWrapper from "../../../../component/TableWrapper";
import { Icons } from "../../../../assets";
import NormalSelect from "../../../../component/NormalSelect";
import classes from "../../style.module.scss";
import { useNavigate } from "react-router-dom";

const LoyaltyProgramList = (props) => {
  const { setAddMembershipModal, handleView, programList, isLoading, } =
    props;
  const ACTIVE = "Active";
  const IN_ACTIVE = "Inactive";
  const dropdownList = [
    { label: ACTIVE, value: [ACTIVE] },
    { label: IN_ACTIVE, value: [IN_ACTIVE] },
  ];

  const [selectedStatus, setSelectedStatus] = useState(ACTIVE);
  const navigate = useNavigate();

  const userHeader = [
    { label: "Level Name" },
    { label: "Rewards" },
    { label: "Status" },
    { label: "Actions" },
  ];

  const handleChange = (value) => {
    setSelectedStatus(Array.isArray(value) ? value?.at(0) : value);
  };

  const handleData = (keyValue, defaultValue, className = "") => {
    return (
      <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
    );
  };

  const handleRewards = (keyValue, defaultValue, className = "", index, id) => {
    return (
      <td className={`${className}`}>
        <div
          className={`${classes.rewardsColumn}`}
          onClick={() => handleView(id)}
        >
          {keyValue ? keyValue : defaultValue}
        </div>
      </td>
    );
  };

  return (
    <>
      <div className={`eventWrapper`}>
        <div className={`mt-2 mb-5`}>
          <TableWrapper
            headerDetails={userHeader}
            pageMeta={programList?.pageMeta}
            // handlePageChange={setPage}
            listLength={programList?.result || []}
            isLoading={isLoading}
          >
            {programList?.result?.map((item, index) => {
              const {
                name = "",
                rewards = "",
                status = "",
                id = "",
              } = item;
              return (
                <tr key={name}>
                  {handleData(name, "-", "text-left")}
                  {handleRewards(rewards, "Reward", "text-center", index, id)}
                  <td className=" px-3 mx-auto text-center w-[130px]">
                    <div className='' style={{
                      color: selectedStatus === ACTIVE ? "#01CB46" : "#FC0000"
                    }}>Active
                    </div>
                  </td>
                  <td className=" px-3 mx-auto text-center action-button">
                    <div className="flex items-center justify-center">
                      <img
                        src={Icons.edit}
                        alt="Edit"
                        className="cursor-pointer w-[18px] h-[16px] mr-2"
                        onClick={() => {
                          setAddMembershipModal(true);
                          navigate(`?type=edit?id=${id}`);
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </TableWrapper>
        </div>
      </div>
    </>
  );
};

export default LoyaltyProgramList;
